import { useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtError } from "../api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) { setErr(fmtError(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="login-screen" data-testid="forgot-screen">
      <div className="login-bg" />
      <form className="login-box" onSubmit={submit}>
        <div className="login-logo">Admatik <span>Rmax</span></div>
        <div className="login-tagline">Reset Password</div>
        {sent ? (
          <div className="alert alert-ok" style={{ marginTop: 12 }} data-testid="forgot-success">
            <span>✓</span> If that email exists, a reset link has been sent. Check your inbox and server logs.
          </div>
        ) : (
          <>
            {err && <div className="login-error">{err}</div>}
            <div className="form-group">
              <div className="login-label">Email</div>
              <input className="login-input" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
            </div>
            <button className="login-btn" type="submit" disabled={busy} data-testid="forgot-submit">
              {busy ? "Sending..." : "Send Reset Link"}
            </button>
          </>
        )}
        <div style={{ textAlign: "center" }}>
          <Link className="login-link" to="/login">← Back to login</Link>
        </div>
      </form>
    </div>
  );
}
